module.exports = __webpack_public_path__ + "media/img/apple-icon-120x120-223e6f152b5dfbc05102d921df8abfce.png";